import { cn as e } from "../../lib/utils.es.js";
import { getCustomIcon as t, hasCustomIcon as n } from "../../lib/customIcons.es.js";
import "react";
import * as r from "lucide-react";
import { jsx as i } from "react/jsx-runtime";
import * as a from "@heroicons/react/24/outline";
import * as o from "@heroicons/react/24/solid";
// libs/ui-lib/src/components/Icon/Icon.tsx
var s = (e) => {
	let { viewBox: t, xmlns: n, fill: r, stroke: i, strokeWidth: a, strokeLinecap: o, strokeLinejoin: s, ...c } = e;
	return c;
}, c = ({ name: c, library: l = "heroicons", variant: u = "outline", size: d = 24, className: f, dataTestId: p = "icon", svgContent: m, src: h, alt: g = "Icon", padding: _ = 2, ...v }) => {
	let y = Math.max(1, d - _ * 2), b = (t) => {
		if (_ > 0) {
			let n = _ === 1 ? "p-px" : _ === 2 ? "p-0.5" : _ === 4 ? "p-1" : _ === 6 ? "p-1.5" : _ === 8 ? "p-2" : _ === 12 ? "p-3" : _ === 16 ? "p-4" : `p-[${_}px]`;
			return /* @__PURE__ */ i("div", {
				"data-testid": p,
				className: e("flex shrink-0 items-center justify-center", n, f),
				style: {
					width: d,
					height: d
				},
				children: t
			});
		}
		return t;
	};
	if (l === "custom") {
		if (h) return b(/* @__PURE__ */ i("img", {
			src: h,
			alt: g,
			width: y,
			height: y,
			"data-testid": _ > 0 ? `${p}--img` : p,
			className: e("shrink-0", _ > 0 ? "" : f),
			...v
		}));
		let r = m;
		if (c && !r && n(c)) {
			let e = t(c);
			e && (r = e.svgContent);
		}
		if (r) {
			let t = r.trim();
			if (!t.startsWith("<")) return b(/* @__PURE__ */ i("img", {
				src: t,
				alt: g,
				width: y,
				height: y,
				"data-testid": _ > 0 ? `${p}--img` : p,
				className: e("shrink-0", _ > 0 ? "" : f),
				...v
			}));
			let n = s(v);
			return b(/* @__PURE__ */ i("div", {
				"data-testid": _ > 0 ? `${p}--svg` : p,
				className: e("shrink-0", _ > 0 ? "" : f),
				style: {
					width: y,
					height: y
				},
				dangerouslySetInnerHTML: { __html: t },
				...n
			}));
		}
		return console.warn("Custom icon requires either a predefined name, svgContent, or src prop"), null;
	}
	if (l === "lucide") {
		if (!(c in r)) return console.warn(`Icon "${c}" not found in Lucide icons`), null;
		let t = r[c];
		return b(/* @__PURE__ */ i(t, {
			"data-testid": _ > 0 ? `${p}--lucide` : p,
			className: e("shrink-0", _ > 0 ? "" : f),
			size: y,
			...v
		}));
	}
	let x = u === "outline" ? a : o;
	if (!(c in x)) return console.warn(`Icon "${c}" not found in Hero Icons ${u} set`), null;
	let S = x[c];
	return b(/* @__PURE__ */ i(S, {
		"data-testid": _ > 0 ? `${p}--hero` : p,
		className: e("shrink-0", _ > 0 ? "" : f),
		width: y,
		height: y,
		...v
	}));
};
c.displayName = "Icon";
export { c as Icon };
